{
  "promoter": {
    "brand": { "name": "CoreWay", "product": "Partners" },
    "common": {
      "signOut": "Sign out",
      "loading": "Loading…",
      "retry": "Try again",
      "copy": "Copy",
      "copied": "Copied",
      "openPdf": "Open PDF",
      "language": "Language"
    },
    "errors": {
      "programClosed": "The promoter program is not open right now. Please come back later.",
      "noInvitation": "There is no invitation for this email address. Sign in with the email your invitation was sent to.",
      "alreadyClaimed": "This invitation is already linked to an account. Sign in with that account.",
      "agreementChanged": "The agreement was updated while you were reading it. Please review the new version.",
      "consentChanged": "The electronic consent text was updated. Please review it again.",
      "consentRequired": "Check the box to agree to electronic records and signatures.",
      "signatureRequired": "Draw your signature in the box first.",
      "signatureTooLarge": "The signature image is too large. Clear it and sign again.",
      "agreementRequired": "Please sign the promoter agreement first.",
      "w9Required": "We need an accepted W-9 before we can pay you.",
      "requestPending": "You already have a payout request waiting for review.",
      "nothingAvailable": "There is nothing available to pay yet.",
      "uploadNotFound": "We could not find your upload. Please choose the file again.",
      "notPdf": "The W-9 must be a PDF file.",
      "tooLarge": "The file must be a PDF of 10 MB or less.",
      "alreadySubmitted": "This file was already submitted.",
      "notAllowed": "This account cannot use the promoter portal.",
      "network": "We could not reach Coreway. Check your connection and try again.",
      "generic": "Something went wrong. Please try again."
    }
  }
}
